const randomString = length => {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
  const charactersLength = characters.length;
  const array = new Uint16Array(length);
  const randomArray = window.crypto.getRandomValues(array);
  for (let i = 0; i < length; i++) {
    result += characters.charAt(randomArray[i] % charactersLength);
  }
  return result;
};

const randomNumericString = length => {
  let result = '';
  const characters = '0123456789';
  const charactersLength = characters.length;
  const array = new Uint16Array(length);
  const randomArray = window.crypto.getRandomValues(array);
  for (let i = 0; i < length; i++) {
    result += characters.charAt(randomArray[i] % charactersLength);
  }
  return result;
};

export const base64Encode = plain => {
  const base64EncodeStr = btoa(plain);
  return base64EncodeStr
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
};

const generateNonce = () => {
  const nonce = randomNumericString(30);
  return nonce;
};

// For the pinxt token call.
// code_verifier = BASE64URL-ENCODE(random_bytes)
const generateCodeVerifier = () => {
  const codeVerifier = randomString(43);
  const encodedCodeVerifier = base64Encode(codeVerifier);
  return encodedCodeVerifier;
};

// For the pinxt auth call
// code_challenge = BASE64URL-ENCODE(SHA256(ASCII(code_verifier))
const generateCodeChallenge = async codeVerifier => {
  const utf8Str = new TextEncoder().encode(codeVerifier);
  const hashBuffer = await crypto.subtle.digest('SHA-256', utf8Str); // hash the message
  const charArray = String.fromCharCode.apply(null, new Uint8Array(hashBuffer)); // convert byte array to string
  return base64Encode(charArray); // base64url encode;
};

export const generatePINXTQueryParams = async client_id => {
  const codeVerifier = generateCodeVerifier();
  const nonce = generateNonce();
  const xsrf = generateCodeVerifier();
  const codeChallenge = await generateCodeChallenge(codeVerifier);

  localStorage.setItem('centralized_authentication_codeVerifier', codeVerifier);
  localStorage.setItem('centralized_authentication_nonce', nonce);
  localStorage.setItem('centralized_authentication_xsrf', xsrf);

  const queryParams = new URLSearchParams();
  queryParams.append('response_type', 'code');
  queryParams.append('client_id', client_id);
  queryParams.append('code_challenge_method', 'S256');
  queryParams.append('code_challenge', codeChallenge);
  queryParams.append('nonce', nonce);

  return queryParams;
};
